interface StatCardProps {
  label: string
  value: string | number
  subtext?: string
  accent?: boolean
}

export default function StatCard({ label, value, subtext, accent }: StatCardProps) {
  return (
    <div className={`glass rounded-xl p-5 ${accent ? 'neon-border-cyan' : ''}`}>
      <p className="font-mono text-[10px] tracking-widest uppercase text-slate-500 mb-2">
        {label}
      </p>
      <p className="font-mono text-2xl text-slate-200" style={{ fontVariantNumeric: 'tabular-nums' }}>
        {value}
      </p>
      {subtext && (
        <p className="font-mono text-xs text-slate-500 mt-1">{subtext}</p>
      )}
    </div>
  )
}
